import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils/common';

import type { TypeReceiveRequestOrder } from '~/types/receive.types';

type TypeReceiveRequestOrderItem = TypeReceiveRequestOrder['items'][number];

/**
 * [입고관리 > 입고요청관리] 입고요청등록 모달 > 2페이지 > 입고 예정 정보 테이블
 */
const getReceiveRegisterOrderInfoColumnDefs = ({ hasPermissionNFA }: { hasPermissionNFA: boolean }) => {
  const columnDefs: TypeTableColumn<TypeReceiveRequestOrderItem>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => formatNumber(row.index + 1),
      size: 72,
    },
    {
      accessorKey: 'goodsCode',
      header: '상품코드',
      size: 150,
    },
    ...(hasPermissionNFA
      ? [{ accessorKey: 'nsid', header: 'NSID', size: 180 } satisfies TypeTableColumn<TypeReceiveRequestOrderItem>]
      : []),
    {
      accessorKey: 'goodsName',
      header: '상품명',
      minSize: 436,
      meta: { flex: true },
    },
    {
      accessorKey: 'unit',
      header: '요청수량',
      size: 87,
      cell: ({ getValue }) => {
        const value = getValue<number | null>();
        return value ? formatNumber(value) : '-';
      },
      meta: { cellStyle: { textAlign: 'right' } },
    },
  ];

  return { columnDefs };
};

export default getReceiveRegisterOrderInfoColumnDefs;
